import React, { useMemo } from 'react';
import { ContentComponentProps } from '../../../utils/pageBuilder/types';

export function PageBuilderHeading({
  children,
  htmlTag
}: ContentComponentProps) {
  const HtmlTag = htmlTag as React.ElementType;
  const className = useMemo(() => {
    switch (htmlTag) {
      case 'h1':
      case 'h2':
        return 'headline-page';
      case 'h3':
      case 'h4':
        return 'headline-session';
      default:
        return 'headline-element-title';
    }
  }, [HtmlTag]);

  return <HtmlTag className={className}>{children}</HtmlTag>;
}
